<template>
  <div>
    <v-overlay :opacity="1" :value="overlay" class="default_overlay">
      <Loading />
    </v-overlay>
    <v-app
      :class="{
        white: whiteBg,
        'ua-theme': isPutinSucks,
        'mobile-app': isMobileApp
      }"
    >
      <template v-if="showHeader">
        <Header :has-border="!isMobileApp" />
        <div class="header-end" />
      </template>
      <v-main>
        <slot />
      </v-main>
      <v-footer
        v-if="!isMobileApp && !isVitalSignsPublic"
        :color="footerWhite ? 'white' : 'undefined'"
        class="pa-0"
        data-cy="footer"
      >
        <Footer />
      </v-footer>
      <ErrorModal />
      <UnsupportedBrowserModal id="unsupported-browser-modal" />
      <UnavailableClinics />
      <CookiesDialog />
      <NeedHelpFab v-if="!isUaRu" />
      <AppLockOverlay v-if="$store.getters['appLock/isAppLockEnabled']" />
      <DeviceNotSecureOverlay />
    </v-app>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import outsideClientZone from '@/mixins/layouts/outsideClientZone';
import Footer from '@/components/Organisms/Footer.vue';
import authUserWatcher from '@/mixins/authUserWatcher';
import Loading from '@/components/Atoms/Loading.vue';
import Header from '@/components/Organisms/Header.vue';
import ErrorModal from '@/components/Atoms/ErrorModal.vue';
import UnsupportedBrowserModal from '@/components/Atoms/UnsupportedBrowserModal.vue';
import AppLockOverlay from '@/feature/app-lock/components/AppLockOverlay.vue';
import DeviceNotSecureOverlay from '@/feature/app-lock/components/DeviceNotSecureOverlay.vue';
import UnavailableClinics from '@/components/Atoms/UnavailableClinics.vue';
import CookiesDialog from '@/components/Organisms/CookiesDialog.vue';
import NeedHelpFab from '@/components/Molecules/NeedHelpFab.vue';
import { localePath, getLanguageSpecificRoutes } from '@/utils/i18nRoutes';
import { routes } from '@/router/routes.js';

export default {
  name: 'DefaultLayout',
  components: {
    AppLockOverlay,
    DeviceNotSecureOverlay,
    NeedHelpFab,
    CookiesDialog,
    UnavailableClinics,
    UnsupportedBrowserModal,
    ErrorModal,
    Header,
    Loading,
    Footer
  },
  mixins: [outsideClientZone, authUserWatcher],
  data() {
    return {
      overlay: true
    };
  },
  computed: {
    ...mapGetters({
      footerWhite: 'general/footerWhite',
      token: 'apiToken/token'
    }),
    whiteBg() {
      return (
        (this.currentPath === 'login' && !this.$auth.user) ||
        (this.currentPath === 'registration' && !this.$route.query.step)
      );
    },
    showHeader() {
      return !(this.isMobileApp && this.$route.meta?.infoPageConfig?.hideHeaderOnMobile);
    },
    isVitalSignsPublic() {
      return this.$route.name?.split('___')[0] === 'vitalSignsPublic';
    }
  },
  beforeMount() {
    this.setIsUlHc(this.$route.name && this.$route.name.indexOf('aeskuLab') !== -1);
  },
  mounted() {
    // const allowedMobileAppRoutes = ['verifyEmail', 'emergency', 'dashboardLock'];
    // const hasChallenge = this.$store.getters['auth/hasSecondFactorChallenge'];

    // if (this.isMobileApp && !allowedMobileAppRoutes.includes(this.currentPath)) {
    //   if (hasChallenge) {
    //     this.goToLocale('dashboardLock');
    //     this.overlay = false;
    //     return;
    //   }
    //   if (this.allowUser) {
    //     this.goToLocale('dashboardLock');
    //   }
    //   if (this.$auth && this.$auth.isLoggedIn) {
    //     this.goToLocale('dashboard');
    //   } else {
    //     this.goToLocale('appLogin', this.$route.query);
    //   }
    // }

    this.overlay = false;

    if (this.showHeader) {
      const observer = new IntersectionObserver(entries => {
        this.$store.dispatch('general/setIsScrolled', !entries[0].isIntersecting);
      });
      observer.observe(document.querySelector('.header-end'));
    }
  },
  methods: {
    ...mapMutations({
      setIsUlHc: 'general/setIsUlHc'
    }),
    goToLocale(name, query = {}) {
      const routeNameFromPathname = Object.entries(routes).find(([, value]) => {
        return value.paths[this.$i18n.locale] === location.pathname;
      })[1].name;

      const path = localePath({
        name,
        query: {
          sard: this.$buildSard({
            query,
            params: this.$route.params,
            page: routeNameFromPathname
          })
        },
        language: this.$route.meta && this.$route.meta.languageKey,
        defaultLanguage: 'cs',
        languageSpecificRoutes: getLanguageSpecificRoutes('cs')
      });
      this.$router.push(path);
    }
  }
};
</script>

<style lang="scss">
body .v-overlay--active.default_overlay {
  .v-overlay__scrim {
    opacity: 1 !important;
    background-color: $white !important;
    border-color: $white !important;
  }
}
</style>
